export default __webpack_public_path__ + "static/media/Orbit.e164ab11.gif";